import react from "react";
import reactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = reactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
